<template>
	<div>
		<v-tooltip bottom>
			<template v-slot:activator="{ on }">
				<div v-on="on">
					<v-btn
						icon
						color="white"
						@click.stop="onClick"
					>
						<v-icon>
							{{ states[index].icon }}
						</v-icon>
					</v-btn>
				</div>
			</template>
			{{ states[index].tooltip }}
		</v-tooltip>
	</div>
</template>

<script>
export default {
	name: 'SortButton',
	data: function() {
		return {
			index: 0,
			states: [{
				value: '',
				icon: 'mdi-pound',
				tooltip: 'Sort by ID (chronologically)'
			}, {
				value: 'name',
				icon: 'mdi-format-text-variant',
				tooltip: 'Sort by (printed) name'
			}, {
				value: 'rarity',
				icon: 'mdi-star-circle-outline',
				tooltip: 'Sort by rarity (rarest first)'
			}, {
				value: 'colnum',
				icon: 'mdi-counter',
				tooltip: 'Sort by collector number (best effort)'
			}, {
				value: 'price',
				icon: 'mdi-cash',
				tooltip: 'Sort by price (most expensive first)'
			}]
		}
	},
	methods: {
		onClick: function() {
			this.index = (this.index + 1) % this.states.length
			this.$emit('input', this.states[this.index].value)
		}
	}
}
</script>
